// components/estimates/EstimateCategoryTabs.js
// Tab per navigazione categorie preventivo

import React from 'react';
import { Card, CardContent } from '../ui/card';

const CATEGORIES = [
  { code: 'A', label: 'Progettazione', color: '#FF7819' },
  { code: 'B', label: 'Pratiche', color: '#FF7819' },
  { code: 'C', label: 'Opere edili', color: '#FF7819' },
  { code: 'D', label: 'Impianti elettrici', color: '#FF7819' },
  { code: 'E', label: 'Impianti idraulici, termici e climatizzazione', short: 'Idraulici, termici e clima', color: '#FF7819' },
  { code: 'F', label: 'Finiture', color: '#FF7819' },
  { code: 'G', label: 'Serramenti', color: '#FF7819' },
  { code: 'H', label: 'Prodotti', color: '#FF7819' },
  { code: 'S', label: 'Sicurezza', color: '#FF7819' },
];

const EstimateCategoryTabs = ({
  activeCategory,
  setActiveCategory,
  categoryTotals
}) => {
  return (
    <Card className="card-abitalo overflow-hidden">
      <CardContent className="p-0">
        {/* Desktop: elegant tab bar */}
        <div className="hidden md:block bg-gradient-to-r from-[#FAFAFA] to-white">
          <div className="flex justify-center py-3 px-4">
            <div className="inline-flex bg-white rounded-xl shadow-sm border border-[#EAEAEA] p-1">
              {CATEGORIES.map(cat => {
                const totals = categoryTotals[cat.code];
                const hasItems = totals?.itemCount > 0;
                const isActive = activeCategory === cat.code;
                
                return (
                  <button
                    key={cat.code}
                    onClick={() => setActiveCategory(cat.code)}
                    className={`relative whitespace-nowrap px-3 py-1.5 text-[13px] font-medium rounded-lg transition-all duration-200 ${
                      isActive 
                        ? 'bg-gradient-to-r from-[#FF7819] to-[#FF9A4D] text-white shadow-md' 
                        : hasItems
                          ? 'text-[#3C3C3C] hover:bg-[#FFF5EE]'
                          : 'text-[#AAAAAA] hover:text-[#666] hover:bg-gray-50'
                    }`}
                    data-testid={`category-tab-${cat.code}`}
                  >
                    <span className={`font-semibold ${isActive ? 'text-white/75' : 'text-[#FF7819]'}`}>{cat.code}</span>
                    <span className="hidden xl:inline font-normal"><span className="mx-1 opacity-40">·</span>{cat.short || cat.label}</span>
                    {hasItems && (
                      <span className={`ml-1.5 text-xs px-1.5 py-0.5 rounded-full font-semibold ${
                        isActive 
                          ? 'bg-white/25 text-white' 
                          : 'bg-[#FF7819] text-white'
                      }`}>
                        {totals.itemCount}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
        
        {/* Mobile: horizontal scroll pills */}
        <div className="md:hidden bg-gradient-to-b from-[#FAFAFA] to-white py-3">
          <div className="overflow-x-auto scrollbar-hide px-4">
            <div className="flex gap-2 min-w-max">
              {CATEGORIES.map(cat => {
                const totals = categoryTotals[cat.code];
                const hasItems = totals?.itemCount > 0;
                const isActive = activeCategory === cat.code;
                
                return (
                  <button
                    key={cat.code}
                    onClick={() => setActiveCategory(cat.code)}
                    className={`flex-shrink-0 flex items-center gap-1.5 px-3.5 py-2 text-[13px] font-medium rounded-full transition-all duration-200 whitespace-nowrap border ${
                      isActive 
                        ? 'bg-gradient-to-r from-[#FF7819] to-[#FF9A4D] text-white border-transparent shadow-lg shadow-orange-200' 
                        : hasItems
                          ? 'bg-white text-[#3C3C3C] border-[#E5E5E5] hover:border-[#FF7819] hover:shadow-sm'
                          : 'bg-gray-50 text-[#AAAAAA] border-gray-200 hover:bg-white'
                    }`}
                    data-testid={`category-tab-mobile-${cat.code}`}
                  >
                    <span className={`font-semibold ${isActive ? '' : 'text-[#FF7819]'}`}>{cat.code}</span>
                    <span className="font-normal">{cat.short || cat.label}</span>
                    {hasItems && (
                      <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${
                        isActive 
                          ? 'bg-white/25 text-white' 
                          : 'bg-[#FF7819]/10 text-[#FF7819]'
                      }`}>
                        {totals.itemCount}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
          {/* Scroll indicator gradient */}
          <div className="pointer-events-none absolute right-0 top-0 h-full w-8 bg-gradient-to-l from-white to-transparent md:hidden" />
        </div>
      </CardContent>
    </Card>
  );
};

export { CATEGORIES };
export default EstimateCategoryTabs;
